import { staticFastlyAppUrl } from "./url-constants";

export const FRANCHISE_DATA_POINTS = [
    "Low Investment",
    "High Returns",
    "Trusted Network",
    "Verified Leads"
];

export const BROCHURE_PDF = `${staticFastlyAppUrl()}/cars24/docs/53_20240520_1716194927.pdf`;
